import { render, staticRenderFns } from "./MobileCartButton.vue?vue&type=template&id=3ef40539&"
import script from "./MobileCartButton.vue?vue&type=script&lang=ts&"
export * from "./MobileCartButton.vue?vue&type=script&lang=ts&"
import style0 from "./MobileCartButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports